import React, { useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft, FiArrowRight, FiAlertTriangle, FiShield } from "react-icons/fi";
import slideTo, { scrollToTop } from "./pageTransition";
import insights from "../data/insights.json";
import "./page-transition.css";
import "./insights.css";

const severityColors = {
  "긴급": "#dc2626",
  "높음": "#ea580c",
  "주의": "#ca8a04",
  "참고": "#2563eb",
};

const severityOrder = { "긴급": 0, "높음": 1, "주의": 2, "참고": 3 };

function formatDate(dateStr) {
  const [year, month, day] = dateStr.split("-");
  return `${year}년 ${parseInt(month)}월 ${parseInt(day)}일`;
}

export default function InsightList() {
  const navigate = useNavigate();

  useLayoutEffect(() => {
    scrollToTop();
    document.title = "보안·IT 이슈 브리핑 | SOLCOMBINE";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute("content", "매일 공개된 공식 발표와 보도를 정리해, 우리 회사가 해당되는지 확인하는 방법과 예방법을 알려드립니다.");
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute("href", "https://solcombine.com/insights");
    }
  }, []);

  const goHome = () => slideTo(navigate, "/", undefined, "back");

  // Sort by severity then date
  const sortedInsights = [...insights].sort((a, b) => {
    const severityDiff = (severityOrder[a.severity] ?? 9) - (severityOrder[b.severity] ?? 9);
    if (severityDiff !== 0) return severityDiff;
    return b.date.localeCompare(a.date);
  });

  return (
    <div className="insight-page">
      <header className="insight-topbar">
        <button type="button" className="insight-back" onClick={goHome}>
          <FiArrowLeft /> 홈으로
        </button>
        <span className="insight-topbar-brand">SOL<span>COMBINE</span></span>
      </header>

      <main className="insight-body">
        <div className="insight-intro">
          <span className="eyebrow">SECURITY BRIEFING</span>
          <h1><FiShield /> 보안·IT 이슈 브리핑</h1>
          <p>매일 공개된 공식 발표와 보도를 정리해, 우리 회사가 해당되는지 확인하는 방법과 예방법을 알려드립니다.</p>
        </div>

        <div className="insight-list">
          {sortedInsights.length === 0 ? (
            <p className="insight-empty">아직 등록된 이슈가 없습니다.</p>
          ) : (
            sortedInsights.map((item) => (
              <article
                key={item.id}
                className="insight-card"
                onClick={() => slideTo(navigate, `/insights/${item.id}`, undefined, "forward")}
              >
                <div className="insight-card-meta">
                  <span
                    className="insight-severity"
                    style={{ "--severity-color": severityColors[item.severity] || "#6b7280" }}
                  >
                    <FiAlertTriangle /> {item.severity}
                  </span>
                  <span className="insight-category">{item.category}</span>
                  <time className="insight-date">{formatDate(item.date)}</time>
                </div>
                <h2>{item.title}</h2>
                <p>{item.summary}</p>
                <span className="insight-card-link">
                  자세히 보기 <FiArrowRight />
                </span>
              </article>
            ))
          )}
        </div>
      </main>

      <footer className="insight-footer">
        <p>솔컴바인은 직접 개발·운영하는 고객사 시스템의 보안을 함께 관리합니다.</p>
      </footer>
    </div>
  );
}
